import { render, staticRenderFns } from "./xgzl.vue?vue&type=template&id=37c3b61e&scoped=true"
import script from "./xgzl.vue?vue&type=script&lang=js"
export * from "./xgzl.vue?vue&type=script&lang=js"
import style0 from "./xgzl.vue?vue&type=style&index=0&id=37c3b61e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c3b61e",
  null
  
)

export default component.exports